import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/images/admin.jpg'


const _hoisted_1 = { class: "row align-items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-xl-4 col-lg-5 col-md-6" }, null, -1)
const _hoisted_3 = { class: "col-xl-8 col-lg-7 col-md-6" }
const _hoisted_4 = { class: "header-right-side d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_5 = { class: "dropdown notification-dropdown" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  class: "dropdown-toggle p-0 position-relative bg-transparent border-0 transition lh-1",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-bell-2" }),
  /*#__PURE__*/_createElementVNode("span", { class: "dot-badge position-absolute fw-bold rounded-circle text-white bg-primary d-inline-block" }, " 3 ")
], -1)
const _hoisted_7 = { class: "dropdown-menu rounded-0 bg-white border-0 start-auto end-0" }
const _hoisted_8 = { class: "title d-flex align-items-center justify-content-between" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-black fw-bold" }, [
  /*#__PURE__*/_createTextVNode("Notifications "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "(03)")
], -1)
const _hoisted_10 = { class: "ps-0 mb-0 list-unstyled dropdown-body" }
const _hoisted_11 = { class: "text-muted position-relative" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "icon rounded-circle position-absolute text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph-bold ph-chat-centered-dots" })
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black-emphasis" }, [
  /*#__PURE__*/_createTextVNode("You have requested to "),
  /*#__PURE__*/_createElementVNode("strong", { class: "fw-semibold" }, "withdrawal")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "unread d-inline-block rounded-circle bg-primary position-absolute w-10 h-10" }, null, -1)
const _hoisted_15 = { class: "text-muted position-relative" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "icon rounded-circle position-absolute text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph-bold ph-user-plus" })
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black-emphasis" }, [
  /*#__PURE__*/_createElementVNode("strong", { class: "fw-semibold" }, "A new user"),
  /*#__PURE__*/_createTextVNode(" added in Adlash ")
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "unread d-inline-block rounded-circle bg-primary position-absolute w-10 h-10" }, null, -1)
const _hoisted_19 = { class: "text-muted position-relative" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "icon rounded-circle position-absolute text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph-bold ph-chat-centered-dots" })
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black-emphasis" }, [
  /*#__PURE__*/_createTextVNode(" You have requested to "),
  /*#__PURE__*/_createElementVNode("strong", { class: "fw-semibold" }, "withdrawal")
], -1)
const _hoisted_22 = { class: "text-center dropdown-footer" }
const _hoisted_23 = { class: "dropdown profile-dropdown" }
const _hoisted_24 = /*#__PURE__*/_createStaticVNode("<button class=\"dropdown-toggle text-start fs-14 text-black-emphasis d-flex align-items-center p-0 position-relative bg-transparent border-0 transition lh-1\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><img src=\"" + _imports_0 + "\" class=\"rounded\" width=\"44\" height=\"44\" alt=\"admin\"><span class=\"title d-none d-lg-block ms-10 ms-lg-15\"><span class=\"d-block fw-bold mb-5 mb-md-8\">Disnel DELLOUH</span><span class=\"text-body-emphasis fw-semibold fs-13\">Admin</span></span></button>", 1)
const _hoisted_25 = { class: "dropdown-menu rounded-0 bg-white border-0 start-auto end-0" }
const _hoisted_26 = { class: "ps-0 mb-0 list-unstyled dropdown-body" }
const _hoisted_27 = { class: "text-body-secondary fw-semibold transition position-relative" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-user-2" }, null, -1)
const _hoisted_29 = { class: "text-body-secondary fw-semibold transition position-relative" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-setting" }, null, -1)
const _hoisted_31 = { class: "text-body-secondary fw-semibold transition position-relative" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-warning" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("body", null, " okok ", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", null, " bonjour ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", {
      class: _normalizeClass([
      'header-area bg-black text-center text-md-start pt-15 pb-15 ps-15 pe-15 ps-md-20 pe-md-20 pe-lg-30 transition w-100 mb-25 position-fixed',
      { sticky: _ctx.isSticky },
    ]),
      id: "header"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode(_component_router_link, {
                    to: "/notifications",
                    class: "text-decoration-none link-btn transition text-primary fw-medium"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Vider ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("ul", _hoisted_10, [
                  _createElementVNode("li", _hoisted_11, [
                    _hoisted_12,
                    _hoisted_13,
                    _createTextVNode(" 2 hrs ago "),
                    _createVNode(_component_router_link, {
                      to: "/notifications",
                      class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                    }),
                    _hoisted_14
                  ]),
                  _createElementVNode("li", _hoisted_15, [
                    _hoisted_16,
                    _hoisted_17,
                    _createTextVNode(" 3 hrs ago "),
                    _createVNode(_component_router_link, {
                      to: "/notifications",
                      class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                    }),
                    _hoisted_18
                  ]),
                  _createElementVNode("li", _hoisted_19, [
                    _hoisted_20,
                    _hoisted_21,
                    _createTextVNode(" 1 day ago "),
                    _createVNode(_component_router_link, {
                      to: "/notifications",
                      class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_router_link, {
                    to: "/notifications",
                    class: "link-btn text-decoration-none text-primary position-relative d-inline-block transition fw-medium fw-medium"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Voir toutes les notifications ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("ul", _hoisted_26, [
                  _createElementVNode("li", _hoisted_27, [
                    _hoisted_28,
                    _createTextVNode(" Mon compte "),
                    _createVNode(_component_router_link, {
                      to: "/profile",
                      class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                    })
                  ]),
                  _createElementVNode("li", _hoisted_29, [
                    _hoisted_30,
                    _createTextVNode(" Parametre "),
                    _createVNode(_component_router_link, {
                      to: "/profile-settings",
                      class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                    })
                  ]),
                  _createElementVNode("li", _hoisted_31, [
                    _hoisted_32,
                    _createTextVNode(" Support "),
                    _createVNode(_component_router_link, {
                      to: "/support-desk-card",
                      class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                    })
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ], 2),
    _hoisted_33,
    _hoisted_34
  ], 64))
}